// export const BaseUrl = "http://localhost:8080/api"
// export const BaseUrl = "https://10.5.49.29:8080/api"



export const BaseUrl = "https://punaah.in:8080/api"


// export const imgurl = "https://punaah.in:8080/uploads/"